import type { CSSProperties, MouseEventHandler } from "react";
import { use } from "react";
import loadIconData from "./loadIconData";

type Props = {
  name: string;
  className: string;
  style: CSSProperties;
  handleClick?: MouseEventHandler<SVGSVGElement>;
};

export default function IconContent({
  name,
  className,
  style,
  handleClick,
}: Props) {
  const icon = use(loadIconData(name));

  return (
    <svg
      style={style}
      onClick={handleClick}
      className={className}
      viewBox={icon.viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {icon.paths}
    </svg>
  );
}
